/* ============
 * Vue Autocomplete
 * ============
 *
 * Autocomplete component for Vue.js
 *
 * https://github.com/paliari/v-autocomplete
 */

import Vue from 'vue'
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'

Vue.use(Autocomplete)



// WEBPACK FOOTER //
// ./src/app/plugins/v-autocomplete.js